<template>
	<div :class="containerClass" @click="onDocumentClick">
		
		<AppTopBar :title="title" 
			:topbarMenuActive="topbarMenuActive" 
			:activeTopbarItem="activeTopbarItem" 
			:inlineUser="inlineUser" 
			@right-menubutton-click="onRightMenuButtonClick"
			@menubutton-click="onMenuButtonClick" 
			@topbar-menubutton-click="onTopbarMenuButtonClick" 
			@topbar-item-click="onTopbarItemClick">
		</AppTopBar>

		

		<transition name="layout-menu-container">
			<div class="layout-menu-container" @click="onMenuClick" v-show="isMenuVisible()">
				<div class="menu-scroll-content">					
					<AppMenu :model="menu" 
					:layoutMode="layoutMode" 
					:active="menuActive" 
					:mobileMenuActive="staticMenuMobileActive" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
				</div>
			</div>
		</transition>
		
		<div class="layout-main">
			<div class="layout-content">
				<router-view/>
			</div>

			

			<AppFooter/>

		</div>


		<div class="layout-content-mask"></div>
	</div>
</template>
<script>
	import AppTopBar from './AppTopbar.vue';	
	import AppMenu from './AppMenu.vue';
	import AppFooter from './AppFooter.vue';
	import EventBus from './event-bus';
	
	export default {

		data() {
			return {
				title: "",
				layoutMode: 'horizontal',
				lightMenu: true,
				overlayMenuActive: false,
				staticMenuMobileActive: false,
				staticMenuDesktopInactive: false,
				isRTL: false,
				inlineUser: false,
				topbarMenuActive: false,
				activeTopbarItem: null,
				rightPanelMenuActive: null,
				inlineUserMenuActive: false,
				menuActive: false,
				//topbarColor: 'layout-topbar-light',
				topbarColor: 'layout-topbar-light',
				
				//topbarColors: [					
				//	{name: "Blue", topbarColor: "layout-topbar-blue", logo: "logo-store-white", color: "#0772B3"}					
				//],
				theme: 'blue',
				//themeColors: [					
				//	{name: "Green", file: "green", color: "#10B163"},
				//],
				menu: []
			}
		},
		
		created(){
			this.title = process.env.VUE_APP_TITLE.toUpperCase();
			var path = this.$route.path;
			//console.log("Router Path:"+path);		
			

				
			
			this.menu = [
				
				{
					label: "Main",icon: "pi pi-list",
					items:[
						{
							label: "Home",
							icon: "pi pi-home",
							command: () => {

								this.$gotoIntro(this);
							
								
							}
						},						
						{
							label: "Products",
							icon: "pi pi-tags",
							command: () => {

								this.$gotoShop(this);
							
								
							},
						},
						{
							label: "Cart",
							icon: "pi pi-shopping-cart",
							command: () => {
								this.$gotoCart(this);
							},
						}						
					]
				},
				/*
				{
					label: "Navigation",icon: "pi pi-globe",
					items:[
						{
							label: "Stores",
							icon: "pi pi-globe",
							command: () => {
								this.$gotoMain(this);
							},
						}
					]
				},*/
				{ label: "Info", icon: "pi pi-table",
					items:[						
						{
							label: "Contact Us",
							icon: "pi pi-send",
							command: () => {
								this.$gotoSupplierContact(this);
							},
						},
						{
							label: "Terms of Service",
							icon: "pi pi-shield",
							command: () => {
								this.$router.push({
									path: "/terms",
								});
							},
						},
						{
							label: "Privacy Statement",
							icon: "pi pi-info-circle",
							command: () => {
								this.$router.push({
									path: "/privacy",
								});
							},
						}
					]
				}				
			];
		},
		
		watch: {
			$route() {
				this.menuActive = false;
				this.$toast.removeAllGroups();
			}
		},
		methods: {
			onDocumentClick() {
				if (!this.topbarItemClick) {
					this.activeTopbarItem = null;
					this.topbarMenuActive = false;
				}

				if (!this.rightMenuClick) {
					this.rightPanelMenuActive = false;
				}

				if (!this.userMenuClick && this.isSlim() && !this.isMobile()) {
					this.inlineUserMenuActive = false;
				}

				if (!this.menuClick) {
					if (this.isHorizontal() || this.isSlim()) {
						this.menuActive = false;
					}

					if (this.overlayMenuActive || this.staticMenuMobileActive) {
						this.hideOverlayMenu();
					}

					EventBus.emit('reset-active-index');
					this.unblockBodyScroll();
				}

				if(this.userMenuClick) {
					this.menuActive = false;
					EventBus.emit('reset-active-index');
				}

				this.topbarItemClick = false;
				this.menuClick = false;
				this.rightMenuClick = false;
				this.userMenuClick = false;
			},
			onMenuButtonClick(event) {
				this.menuClick = true;
				this.topbarMenuActive = false;
				this.rightPanelMenuActive = false;

				if (this.layoutMode === 'overlay') {
					this.overlayMenuActive = !this.overlayMenuActive;
				}

				if (this.isDesktop())
					this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
				else {
					this.staticMenuMobileActive = !this.staticMenuMobileActive;
					if (this.staticMenuMobileActive) {
						this.blockBodyScroll();
					} else {
						this.unblockBodyScroll();
					}
				}

				event.preventDefault();
			},
			onTopbarMenuButtonClick(event) {
				this.topbarItemClick = true;
				this.topbarMenuActive = !this.topbarMenuActive;
				this.hideOverlayMenu();
				event.preventDefault();
			},
			onTopbarItemClick(event) {
				this.topbarItemClick = true;

				if (this.activeTopbarItem === event.item)
					this.activeTopbarItem = null;
				else
					this.activeTopbarItem = event.item;

				event.originalEvent.preventDefault();
			},
			onMenuClick() {
				this.menuClick = true;
			},
			onInlineUserClick() {
				this.userMenuClick = true;
				this.inlineUserMenuActive = !this.inlineUserMenuActive;
			},
			blockBodyScroll() {
                this.addClass(document.body, 'blocked-scroll');
			},
			unblockBodyScroll() {
                this.removeClass(document.body, 'blocked-scroll');
			},
			onRightMenuButtonClick(event) {
				this.rightMenuClick = true;
				this.rightPanelMenuActive = !this.rightPanelMenuActive;

				this.hideOverlayMenu();

				event.preventDefault();
			},
			onRightMenuClick() {
				this.rightMenuClick = true;
			},
			hideOverlayMenu() {
				this.overlayMenuActive = false;
				this.staticMenuMobileActive = false;
			},
			onMenuItemClick(event) {
				if (!event.item.items) {
					EventBus.emit('reset-active-index');
					this.hideOverlayMenu();
				}
				if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
					this.menuActive = false;
				}
			},
			onRootMenuItemClick() {
				this.menuActive = !this.menuActive;
			},
			isTablet() {
				let width = window.innerWidth;
				return width <= 1024 && width > 640;
			},
			isDesktop() {
				return window.innerWidth > 896;
			},
			isMobile() {
				return window.innerWidth <= 1025;
			},
			isHorizontal() {
				return this.layoutMode === 'horizontal';
			},
			isSlim() {
				return this.layoutMode === 'slim';
			},
			isMenuVisible() {
				if (this.isDesktop()) {
					if (this.layoutMode === 'static')
						return !this.staticMenuDesktopInactive;
					else if (this.layoutMode === 'overlay')
						return this.overlayMenuActive;
					else
						return true;
				} else {
					return true;
				}
			},
			

			//change stylesheet 
			changeStyleSheetUrl(id, value, prefix) {
				let element = document.getElementById(id);
				let urlTokens = element.getAttribute('href').split('/');
				urlTokens[urlTokens.length - 1] = prefix + '-' + value + '.css';
				let newURL = urlTokens.join('/');

				this.replaceLink(element, newURL);
			},
			//remove old link and add new one
			replaceLink(linkElement, href) {
				const id = linkElement.getAttribute('id');
				const cloneLinkElement = linkElement.cloneNode(true);

				cloneLinkElement.setAttribute('href', href);
				cloneLinkElement.setAttribute('id', id + '-clone');

				linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

				cloneLinkElement.addEventListener('load', () => {
					linkElement.remove();
					cloneLinkElement.setAttribute('id', id);
				});
			},

			//add new css class
            addClass(element, className) {
                if (element.classList)
                    element.classList.add(className);
                else
                    element.className += ' ' + className;
            },
			//remove existing css class
            removeClass(element, className) {
                if (element.classList)
                    element.classList.remove(className);
                else
                    element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
		},
		computed: {
			containerClass() {
				return ['layout-wrapper', {
					'layout-horizontal': this.layoutMode === 'horizontal',
					'layout-overlay': this.layoutMode === 'overlay',
					'layout-static': this.layoutMode === 'static',
					'layout-slim': this.layoutMode === 'slim',
					'layout-menu-light': this.lightMenu === true,
					'layout-menu-dark': this.lightMenu === false,
					'layout-overlay-active': this.overlayMenuActive,
					'layout-mobile-active': this.staticMenuMobileActive,
					'layout-static-inactive': this.staticMenuDesktopInactive,
					'layout-rtl': this.isRTL,
					'p-input-filled': this.$primevue.config.inputStyle === 'filled',
					'p-ripple-disabled': this.$primevue.config.ripple === false
				}, this.topbarColor];
			}
		},
		components: {
			'AppTopBar': AppTopBar,			
			'AppMenu': AppMenu,			
			'AppFooter': AppFooter
		}
	}
</script>
<style lang="scss">

.layout-wrapper {

    .layout-topbar {
        height: 59px !important;        
        padding: 7px 9px !important;
       
	}

	.layout-menu-container {
		top: 59px !important;
	}
}


@media screen and (max-width: 896px) {
    .layout-wrapper {
        .layout-topbar {
            height: 59px !important;
			padding: 7px 9px !important;
        }
    }
}




</style>
